<template>
  <section>
    <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
    <div v-show="isValidToken && !isLoading" class="hero">
      <div class="hero-body container container box has-background-white-bis">
        <div class="steps" id="stepsDemo">
          <div class="step-item is-active is-success">
            <div class="step-marker">1</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Documents" class="fal fa-folder-open fa-lg"></i>
              </p>
              <p class="step-title" v-else>DOCUMENTS</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-marker">2</div>
            <div class="step-details">
              <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Terms" class="fal fa-file-signature fa-lg"></i>
              </p>
              <p class="step-title" v-else>TERMS</p>
            </div>
          </div>
          <div class="steps-content">
            <div class="step-content">
              <form class="has-text-centered" data-vv-scope="step1">
                <section class="has-text-left">
                  <div class="notification has-background-grey-dark has-text-white">
                    Please provide driver's license and insurance card'
                  </div>
                <div class="is-full">
                  <div class="field is-full">
                    <file-selector v-model="driversPhotoFiles" label="Drivers License" :multiple="false" :token="this.token" scope="step1" destinationUrl="/upload/receive"></file-selector>
                  </div>
                  <div class="field is-full" v-if="stateRequiredBackOfDriversLicense">
                    <file-selector v-model="backOfDriversPhotoFiles" label="Back Of Drivers License" :multiple="false" :token="this.token" scope="step1" destinationUrl="/upload/receive"></file-selector>
                  </div>
                  <div class="field is-full">
                    <file-selector v-model="insurancePhotoFiles" label="Insurance Card" :multiple="false" :token="this.token" scope="step1" destinationUrl="/upload/receive"></file-selector>
                  </div>
                </div>
                </section>
              </form>
            </div>
            <div class="step-content">
              <form class="has-text-centered" data-vv-scope="step2">
                <section class="has-text-left">
                  <div class="notification has-background-grey-dark has-text-white">
                    Please review and accept the terms and conditions
                  </div>
                  <div v-observe-visibility="visibilityChanged">
                    <div class="field">
                      <generic-terms-control v-model="customerTermsAccepted"></generic-terms-control>
                    </div>
                  </div>
                </section>
              </form>
            </div>
          </div>
          <div class="steps-actions">
            <div class="steps-action">
              <b-button icon-left="chevron-left" data-nav="previous" class="is-light" :disabled="hasSaved">Previous</b-button>
            </div>
            <div class="steps-action">
              <b-button icon-right="chevron-right" data-nav="next" class="next-step"  @click='validateStep' :disabled="hasSaved">Next</b-button>
            </div>
            <div class="steps-action" v-if="termsVisible && canSave">
              <a class="button next-step" @click="validateBeforeSubmit" :disabled="hasSaved">Submit</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isValidToken && isLoading" class="hero">
      <div class="hero-body container">
        <div class="container is-fluid">
          <div class="columns is-vcentered loadingContainer">
            <div class="column is-12 has-text-centered has-text-weight-semi-bold">
              <img src="@/assets/ajax-loader.gif">
              <div v-if="!loadingBaseData">Verifying your identity....</div>
              <div v-if="loadingBaseData">Loading base data....</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isValidToken && !isLoading" class= "hero">
      <div class="hero-body container"></div>
    </div>
  </section>
</template>

<script>
import bulmaSteps from 'bulma-steps/dist/js/bulma-steps'
import customerService from '@/services/customerService'
import customerMixin from '@/mixins/customer/index'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import FileSelector from '@/components/generic/FileSelector'
import utilitiesMixin from '@/mixins/generic/utilities'
import { mapActions } from 'vuex'
import GenericTermsControl from '@/components/generic/GenericTermsControl'

export default {
  name: 'IdentityVerification',
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  components: {
    'error-display-component': ErrorDisplayComponent,
    'file-selector': FileSelector,
    'generic-terms-control': GenericTermsControl
  },
  mixins: [validateBeforeSubmitMixin, customerMixin, utilitiesMixin],
  data () {
    return {
      mobile: window.innerWidth <= 700,
      isLoading: false,
      itemsHidden: true,
      addresses: [],
      currentStep: 0,
      termsVisible: false,
      customerDriverLicenseState: {},
      isSaving: false,
      todayDate: new Date(),
      allStates: [],
      canSave: false,
      serverErrors: [],
      serverErrorMessage: '',
      isValidToken: false,
      preventClick: false,
      loadingBaseData: false,
      hasSaved: false,
      driversPhotoFiles: [],
      insurancePhotoFiles: [],
      customerEmailValid: false,
      customerFirstNameValid: false,
      customerLastNameValid: false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      currentUrl: '',
      currentCustomer: {
        imageName: null,
        fileName: null,
        fileLocation: null,
        driversImageName: null,
        driversFileName: null,
        driversFileLocation: null,
        insuranceImageName: null,
        insuranceFileName: null,
        insuranceFileLocation: null,
        uploadName: null,
        uniqueId: null,
        driversUploadName: null,
        driversUniqueId: null,
        insuranceUploadName: null,
        insuranceUniqueId: null,
        backOfDriversImageName: '',
        backOfDriversFileName: '',
        backOfDriversFileLocation: '',
        backOfDriversUploadName: '',
        backOfDriversUniqueId: '',
        driverLicenseState: '',
        customerName: '',
        token: '',
        id: 0,
        isTermsAccepted: false
      },
      datePickerOptions: {
        disabledDate (date) {
          return date > new Date()
        },
        defaultView: 'year'
      },
      availableScopes: ['step1', 'step2', 'step3', 'step4'],
      currentSsn: '',
      canEditSsn: false,
      backOfDriversPhotoFiles: [],
      customerTermsAccepted: false
    }
  },
  computed: {
    stateOptions: function () {
      return this.allStates.map(d => ({ text: d.text, value: d.value }))
    },
    currentCustomerName: function () {
      return this.currentCustomer.customerName
    },
    isTermsAccepted: function () {
      return this.currentCustomer.isTermsAccepted
    },
    currentScope: function () {
      return this.availableScopes[this.currentStep]
    },
    stateRequiredBackOfDriversLicense: function () {
      if (this.allStates && this.allStates.length > 0 && this.currentCustomer && this.currentCustomer.driverLicenseState) {
        const lowerCaseStateName = this.currentCustomer.driverLicenseState.toLowerCase()
        const state = this.allStates.find((x) => x.name.toLowerCase() === lowerCaseStateName)
        return state.requiresBackOfDriversLicense
      }
      return false
    },
    informationTitle: function () {
      if (this.currentCustomerName) {
        return 'Dear ' + this.currentcustomerName + ', please provide driver\'s license and insurance card'
      }
      return 'Dear Sir/Madam Please provide driver\'s license and insurance card'
    }
  },
  methods: {
    ...mapActions(['updateReturnUrl', 'updateIsContinueLater']),
    fetchCustomerDocumentverification: function (currentToken) {
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      customerService.getCustomerDocumentVerification(currentToken).then(response => {
        this.currentCustomer = {
          ...response.customerdata
        }
        this.isValidToken = true
        this.isLoading = false
        this.initInputValues()
      }).catch((error) => {
        this.isLoading = false
        this.serverErrorMessage = 'Could not load customer with token: ' + currentToken
        this.isValidToken = false
        console.log(error)
      })
    },
    initInputValues () {
      if (this.currentCustomer != null) {
        if (this.currentCustomer.driversFileLocation) {
          var driversPhotoFile = {
            loaded: true,
            imageData: this.currentCustomer.driversFileLocation,
            fileName: this.currentCustomer.driversFileName,
            fileLocation: this.currentCustomer.driversFileLocation,
            name: this.currentCustomer.driversImageName,
            fileType: this.getFileType(this.currentCustomer.driversFileLocation)
          }

          this.driversPhotoFiles.push(driversPhotoFile)
        }
        if (this.currentCustomer.backOfDriversFileLocation) {
          var backOfDriversPhotoFile = {
            loaded: true,
            imageData: this.currentCustomer.backOfDriversFileLocation,
            fileName: this.currentCustomer.backOfDriversFileName,
            fileLocation: this.currentCustomer.backOfDriversFileLocation,
            name: this.currentCustomer.driversImageName,
            fileType: this.getFileType(this.currentCustomer.backOfDriversFileLocation)
          }

          this.backOfDriversPhotoFiles.push(backOfDriversPhotoFile)
        }
        if (this.currentCustomer.insuranceFileLocation) {
          var insurancePhotoFile = {
            loaded: true,
            imageData: this.currentCustomer.insuranceFileLocation,
            fileName: this.currentCustomer.insuranceFileName,
            fileLocation: this.currentCustomer.insuranceFileLocation,
            name: this.currentCustomer.insuranceImageName,
            fileType: this.getFileType(this.currentCustomer.insuranceImageName)
          }

          this.insurancePhotoFiles.push(insurancePhotoFile)
        }
      } else {
        this.serverErrorMessage = 'Could not load customer information'
      }
    },
    visibilityChanged (isVisible, entry) {
      this.termsVisible = isVisible
    },
    fetchAllStates: function () {
      customerService.allStates().then(response => {
        this.allStates = response.results
      }).catch((error) => {
        this.serverErrorMessage = error.message
      })
    },
    onSave: function () {
      this.save()
    },
    evaluateRequiredTermsVisibility () {
      this.evaluateValidToSubmit()
    },
    evaluateValidToSubmit () {
      this.canSave = this.customerTermsAccepted
    },
    onComplete () {
      this.$router.push({ name: 'CustomerDocumentVerificationComplete' })
    },
    resetCurrentCustomer () {
      this.currentCustomer = {
        imageName: null,
        fileName: null,
        fileLocation: null,
        driversImageName: null,
        driversFileName: null,
        driversFileLocation: null,
        insuranceImageName: null,
        insuranceFileName: null,
        insuranceFileLocation: null,
        insuranceUploadName: null,
        insuranceUniqueId: null,
        driversUploadName: null,
        driversUniqueId: null,
        uploadName: null,
        uniqueId: null,
        backOfDriversImageName: '',
        backOfDriversFileName: '',
        backOfDriversFileLocation: '',
        backOfDriversUploadName: '',
        backOfDriversUniqueId: '',
        driverLicenseState: '',
        customerName: '',
        token: '',
        id: 0,
        isTermsAccepted: false
      }
    },
    async saveAndContinueLater () {
      this.currentCustomer.isContinueLater = true
      this.currentCustomer.url = this.currentUrl
      await this.updateReturnUrl(this.currentUrl)
      await this.updateIsContinueLater(true)
      this.save()
    },
    save () {
      var customerModel = {
        imageName: null,
        fileName: null,
        fileLocation: null,
        driversImageName: null,
        driversFileName: null,
        driversFileLocation: null,
        uploadName: null,
        uniqueId: null,
        driversUploadName: null,
        driversUniqueId: null,
        driverLicenseState: this.currentCustomer.driverLicenseState || '',
        customerName: this.currentCustomer.customerName,
        insuranceImageName: null,
        insuranceFileName: null,
        insuranceFileLocation: null,
        insuranceUploadName: null,
        insuranceUniqueId: null,
        id: this.currentCustomer.id,
        backOfDriversImageName: this.currentCustomer.backOfDriversImageName,
        backOfDriversFileName: this.currentCustomer.backOfDriversFileName,
        backOfDriversFileLocation: this.currentCustomer.backOfDriversFileLocation,
        backOfDriversUploadName: this.currentCustomer.backOfDriversUploadName,
        backOfDriversUniqueId: this.currentCustomer.backOfDriversUniqueId,
        token: this.token
      }
      //
      this.hasSaved = true

      customerModel.uploadName = this.currentCustomer.uploadName
      customerModel.uniqueId = this.currentCustomer.uniqueId

      if (this.driversPhotoFiles.length > 0) {
        var driversPhotoFile = this.driversPhotoFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        customerModel.driversUploadName = driversPhotoFile[0].uploadName
        customerModel.driversUniqueId = driversPhotoFile[0].uniqueId
      } else {
        customerModel.driversUploadName = ''
        customerModel.driversUniqueId = ''
      }

      if (this.backOfDriversPhotoFiles.length > 0) {
        var backOfDriversPhotoFile = this.backOfDriversPhotoFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        customerModel.backOfDriversUploadName = backOfDriversPhotoFile[0].uploadName
        customerModel.backOfDriversUniqueId = backOfDriversPhotoFile[0].uniqueId
      } else {
        customerModel.backOfDriversUploadName = ''
        customerModel.backOfDriversUniqueId = ''
      }

      if (this.insurancePhotoFiles.length > 0) {
        var insurancePhotoFile = this.insurancePhotoFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uniqueId: x.uniqueId
          }
        })

        customerModel.insuranceUploadName = insurancePhotoFile[0].uploadName
        customerModel.insuranceUniqueId = insurancePhotoFile[0].uniqueId
      } else {
        customerModel.insuranceUploadName = ''
        customerModel.insuranceUniqueId = ''
      }

      this.isSaving = true
      this.serverErrorMessage = ''
      this.serverErrors = []

      customerService.updateDocumentVerification(customerModel).then(response => {
        this.isSaving = false
        if (response.errors) {
          this.serverErrors = response.errors
          this.$nextTick(function () {
            var elmnt = document.getElementById('main-page')
            elmnt.scrollTo(0, 0)
          })
          this.hasSaved = false
        } else {
          this.$emit('on-save', response.customer)
          this.onChangesSaved()
          this.onComplete()
          this.hasSaved = false
        }
      }).catch((error) => {
        this.serverErrorMessage = error.message
        this.isSaving = false
        this.$nextTick(function () {
          var elmnt = document.getElementById('main-page')
          elmnt.scrollTo(0, 0)
        })
        this.hasSaved = false
      })
    },
    async validateStep (e) {
      this.preventClick = false
      this.$validator.validate(this.currentScope + '.*').then((result) => {
        if (result === false) {
          this.preventClick = true
          this.$goToFirstValidationError(this.$validator.errors.items.filter((x) => x.scope === this.currentScope))
        }
      })
    },
    checkRemoveButtonVisibility (dataCollection) {
      if (dataCollection.length > 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.currentUrl = window.location.href
    this.$emit('is-home', false)
  },
  mounted () {
    bulmaSteps.attach('.steps', {
      beforeNext: id => {
        var beforeNextResult = {}
        if (this.preventClick) {
          beforeNextResult.errors = ['Error occured']
          return beforeNextResult
        } else {
          return beforeNextResult
        }
      },
      beforePrevious: id => {
        this.currentStep = id
      },
      onShow: id => {
        var elmnt = document.getElementById('main-page')
        elmnt.scrollTo(0, 0)
        this.currentStep = id
      }
    })
    this.fetchAllStates()
    this.resetCurrentCustomer()
    this.fetchCustomerDocumentverification(this.token)
    this.$emit('set-title-one', 'DOCUMENT')
    this.$emit('set-title-two', 'VERIFICATION')
  },
  watch: {
    isTermsAccepted () {
      this.evaluateValidToSubmit()
    },
    token: function (newValue, oldValue) {
      this.isValidToken = false
      this.fetchAllStates()
      this.fetchCustomerDocumentverification(this.token)
    },
    customerTermsAccepted: function (newValue, oldValue) {
      this.canSave = newValue
    }
  }
}

</script>

<style scoped>

</style>
